// WebAuthn browser bridge: base64url <-> ArrayBuffer + navigator.credentials wrappers.

function base64UrlToBuffer(base64Url) {
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  // Hoisted, not parenthesised: no-mixed-operators and no-extra-parens each
  // reject the other's form, and --fix oscillates between them.
  const remainder = base64.length % 4;
  const padding = remainder === 0 ? 0 : 4 - remainder;
  const padded = base64.padEnd(base64.length + padding, "=");
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

function bufferToBase64Url(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function isPasskeySupported() {
  return typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;
}

export async function createPasskey(options) {
  const publicKey = {
    challenge: base64UrlToBuffer(options.challenge),
    rp: options.rp,
    user: {
      id: base64UrlToBuffer(options.user.id),
      name: options.user.name,
      displayName: options.user.displayName,
    },
    pubKeyCredParams: options.pubKeyCredParams,
    timeout: options.timeout,
    attestation: options.attestation,
    authenticatorSelection: options.authenticatorSelection,
    excludeCredentials: (options.excludeCredentials || []).map(credential => ({
      type: credential.type,
      id: base64UrlToBuffer(credential.id),
    })),
  };
  const credential = await navigator.credentials.create({ publicKey });
  return {
    client_data_json: bufferToBase64Url(credential.response.clientDataJSON),
    attestation_object: bufferToBase64Url(credential.response.attestationObject),
    transports: credential.response.getTransports ? credential.response.getTransports() : [],
  };
}

export async function getPasskeyAssertion(options) {
  const publicKey = {
    challenge: base64UrlToBuffer(options.challenge),
    rpId: options.rpId,
    timeout: options.timeout,
    userVerification: options.userVerification,
    allowCredentials: (options.allowCredentials || []).map(credential => ({
      type: credential.type,
      id: base64UrlToBuffer(credential.id),
      transports: credential.transports,
    })),
  };
  const assertion = await navigator.credentials.get({ publicKey });
  return {
    credential_id: bufferToBase64Url(assertion.rawId),
    client_data_json: bufferToBase64Url(assertion.response.clientDataJSON),
    authenticator_data: bufferToBase64Url(assertion.response.authenticatorData),
    signature: bufferToBase64Url(assertion.response.signature),
  };
}
